module.exports = __webpack_public_path__ + "img/touchpanel.70e76f60.png";